import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@aqarmap/aqarmap-ui';
import useSidebarLinks, {
  LinkType,
} from '~/modules/myAccount/components/Sidebar/useSidebarLinks';
import { Languages } from '~/constants/enums';
import Skeleton from 'react-loading-skeleton';
import { useGetUserQuery } from '~/redux/api/userApiSlice';

const Sidebar = () => {
  const { data: response, isLoading, isSuccess } = useGetUserQuery();
  const location = useLocation();
  const { i18n, t } = useTranslation('app');
  const locale = i18n.language;
  const userType = response?.user.user_type;
  const links = useSidebarLinks(userType as number);

  function isActive(link: LinkType) {
    const pathname = location.pathname.replace(/\/+$/, '');

    const otherLinks = pathname.startsWith(link.url) && !link.subUrl;

    return pathname === link.url || pathname === link.subUrl || otherLinks;
  }
  return (
    <aside className="pb-10x">
      <nav>
        {isLoading && (
          <ul className="flex flex-col gap-x">
            {Array(3)
              .fill(0)
              .map((_, i) => (
                <li key={i} className="w-full lg:w-[248px]">
                  <Skeleton height={40} baseColor="#E0E0E0" borderRadius={8} />
                </li>
              ))}
          </ul>
        )}
        {!isLoading && isSuccess && (
          <ul className="flex flex-col gap-x">
            {links.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.url}
                  className={`rounded-[8px] group w-full lg:w-[248px] hover:text-blue transition-all duration-200 flex gap-1.5x items-center justify-between lg:justify-start h-full px-1.5x py-x ${
                    isActive(link)
                      ? 'lg:bg-blue_light_2 lg:text-blue text-black'
                      : ''
                  } font-normal hover:bg-blue_light_2`}
                >
                  <div className="flex items-center gap-1.5x">
                    <Icon
                      className="group-hover:text-blue text-inherit "
                      name={link.icon}
                    />
                    <span className="text-body_1">{t(link.title)}</span>
                  </div>
                  <div className="lg:hidden">
                    <Icon
                      name="chevron-left"
                      className={`text-inherit ${locale === Languages.ENGLISH ? 'rotate-180' : ''}`}
                    />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
